import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListSupportKpi extends GuiListGeneric {
    constructor() {
        super("Kpi");
    }
}
